import React from 'react';
import { render } from 'react-dom';
import 'antd/dist/antd.css';
import './index.less';
import App from './App/App';

render(
   <App />,
   document.getElementById('root')
);